import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { blue } from "@mui/material/colors";

export const AccessReviewStatusChip = ({ status, type = "status" }) => {
  const theme = useTheme();

  const getStatusConfig = (status, type) => {
    if (type === "role" || type === "note") {
      const hasRole = status && status !== "Not Assigned" && status !== "No notes available";
      return {
        label: status || "Not Assigned",
        color: hasRole ? "primary.main" : "text.secondary",
        bgColor: hasRole ? "rgba(26,86,219,0.08)" : "background.paper",
        icon: null,
        isRole: true,
      };
    }

    const statusUpper = (status || "").toUpperCase();
    
    if (statusUpper === "APPROVED") {
      return {
        label: "Approved",
        color: theme.customColors.status.success.text,
        bgColor: theme.customColors.status.success.bg,
        isRole: false,
      };
    } else if (statusUpper === "REJECTED") {
      return {
        label: "Rejected",
        color: theme.customColors.status.error.text,
        bgColor: theme.customColors.status.error.bg,
        isRole: false,
      };
    } else if (statusUpper === "MODIFIED" || statusUpper === "MODIFY") {
      return {
        label: "Modified",
        color: theme.customColors.status.warning?.text || "#D97706",
        bgColor: theme.customColors.status.warning?.bg || "#FEF3C7",
        isRole: false,
      };
    }
    return {
      label: status || "Pending",
      color: theme.customColors.status.info.text,
      bgColor: theme.customColors.status.info.bg,
      isRole: false,
    };
  };

  const config = getStatusConfig(status, type);

  return (
    <Chip
      label={config.label}
      icon={config.icon}
      sx={{
        backgroundColor: config.bgColor,
        color: config.color,
        fontWeight: config.isRole ? 500 : 600,
        fontSize: "0.75rem",
        height: config.isRole ? "24px" : "30px",
        borderRadius: config.isRole ? 1 : 0,
        px: config.isRole ? 1.5 : 0,
        minWidth: config.isRole ? "auto" : "90px",
        textAlign: config.isRole ? "left" : "center",
        border: "none",
        boxShadow: config.isRole ? "none" : "none",
        "& .MuiChip-icon": {
          color: config.color,
          marginLeft: "8px",
        },
        "& .MuiChip-label": {
          px: config.isRole ? 0.2 : 0,
        },
      }}
    />
  );
};
